import {
    configureStore,
    Store
} from '@reduxjs/toolkit';


import {DomainNamesReducer} from '../features/domain-names/reducers/index'
import {TopLevelDomainsReducer} from '../features/top-level-domains/reducers/index'
import {RegistrarsReducer} from '../features/registrars/reducers/index'

const reducers = {
    domainNames: DomainNamesReducer,
    topLevelDomains: TopLevelDomainsReducer,
    registrars: RegistrarsReducer,
};

// added this middleware  to disable this error - A non-serializable value was detected in the state, in the path...
// @todo disable if better way is found
// FNP-960: a factory so tests can build an isolated store, optionally seeded.
// The test harness accepted a `preloadedState` argument and then rendered
// against the shared singleton below, so seeding was silently ignored AND state
// leaked between cases. Same defect as flexinet-marketplace-app (FNP-958).
export const setupStore = (preloadedState?: Parameters<typeof configureStore>[0]['preloadedState']): Store =>
    configureStore({
                       reducer: reducers,
                       preloadedState,
                       middleware: (getDefaultMiddleware) =>
                           getDefaultMiddleware({
                                                    serializableCheck: false,
                                                }),
                   });

export const store: Store = setupStore();


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch